import React from 'react';
import { Check, ArrowRight, Lock, CreditCard } from 'lucide-react';
import { Button } from './Button';
export function OfferSection() {
  return <section id="compra" className="py-20 bg-white px-4 scroll-mt-10" data-id="element-89">
      <div className="max-w-5xl mx-auto" data-id="element-90">
        <div className="text-center mb-12" data-id="element-91">
          <h2 className="text-4xl md:text-6xl font-black text-gray-900 mb-4" data-id="element-92">
            Tu negocio trabajando 24/7{' '}
            <span className="text-brand-red" data-id="element-93">empieza aquí.</span>
          </h2>
          <p className="text-xl text-gray-600" data-id="element-94">
            Obtén acceso inmediato a todo el sistema.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 items-center justify-center" data-id="element-95">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 max-w-md" data-id="element-96">
            <div className="relative" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/ubmyg3kA736MVZC5WYYpLU/Flujos_listos_para_proyectos_rapidos.png" alt="Bonus 80 Flujos" className="w-full rounded-2xl shadow-2xl aspect-square object-cover border-4 border-gray-100" data-id="element-98" />
              <div className="absolute -top-4 -right-4 bg-brand-yellow text-black font-black px-4 py-2 rounded-lg shadow-lg transform rotate-6 border-2 border-black" data-id="element-99">
                + BONUS GRATIS
              </div>
            </div>
          </div>

          {/* Pricing Box */}
          <div className="w-full lg:w-1/2 max-w-md" data-id="element-100">
            <div className="bg-white rounded-2xl shadow-2xl border-4 border-brand-red overflow-hidden relative" data-id="element-101">
              <div className="bg-brand-red text-white text-center py-3 font-bold uppercase tracking-wider" data-id="element-102">
                Oferta Especial de Lanzamiento
              </div>

              <div className="p-8" data-id="element-103">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-104">
                  Lo que te llevas hoy:
                </h3>

                <ul className="space-y-4 mb-8" data-id="element-105">
                  {['Tomo I: Fundamentos n8n', 'Tomo II: Ingeniería de Datos', 'Tomo III: Ecosistemas con IA', 'Tomo IV: El Negocio y Ventas', 'BONUS: 80 Blueprints JSON listos', 'Acceso de por vida', 'Actualizaciones futuras gratis'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-106">
                      <Check className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-107" />
                      <span className="font-medium text-gray-700" data-id="element-108">{item}</span>
                    </li>)}
                </ul>

                <div className="text-center mb-8 bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-109">
                  <p className="text-gray-500 font-medium mb-1" data-id="element-110">
                    Valor Total: <span className="line-through" data-id="element-111">$46.990</span>
                  </p>
                  <div className="flex items-center justify-center gap-2" data-id="element-112">
                    <span className="text-5xl font-black text-gray-900" data-id="element-113">
                      $19.990
                    </span>
                    <span className="text-sm text-gray-500 font-medium text-left leading-tight" data-id="element-114">
                      Pago
                      <br data-id="element-115" />
                      Único
                    </span>
                  </div>
                </div>

                <Button href="https://www.digitalesia.shop/cart/52199768916261:1" fullWidth className="animate-pulse-fast text-lg md:text-xl" data-id="element-116">
                  Acceder a la Saga + 80 Blueprints
                </Button>

                <div className="mt-6 text-center" data-id="element-117">
                  <div className="flex items-center justify-center gap-4 mb-2" data-id="element-118">
                    {/* Visa logo inline */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 471" className="h-8 opacity-60" data-id="element-119">
                      <rect width="750" height="471" rx="40" fill="#fff" stroke="#d4d4d8" strokeWidth="8" data-id="element-120" />
                      <path d="M278.2 334.2h-60.6l37.9-233.9h60.6L278.2 334.2z" fill="#3C58BF" data-id="element-121" />
                      <path d="M524.3 105.2c-12-4.5-30.8-9.4-54.3-9.4-59.8 0-101.9 31.8-102.3 77.3-.4 33.7 30 52.4 52.9 63.6 23.5 11.5 31.4 18.8 31.3 29.1-.2 15.7-18.8 22.9-36.1 22.9-24.1 0-36.9-3.5-56.7-12.2l-7.8-3.7-8.4 52.2c14.1 6.5 40.1 12.2 67.1 12.5 63.6 0 104.9-31.4 105.4-80 .3-26.7-15.9-47-50.8-63.7-21.2-10.8-34.1-18.1-34-29.1 0-9.7 11-20.1 34.6-20.1 19.8-.3 34.1 4.2 45.2 9l5.4 2.7 8.2-51.1z" fill="#3C58BF" data-id="element-122" />
                      <path d="M661.6 100.3h-46.8c-14.5 0-25.3 4.2-31.7 19.5l-89.9 214.4h63.6s10.4-28.8 12.7-35.2h77.7c1.8 8.2 7.4 35.2 7.4 35.2H710L661.6 100.3zm-74.5 185.4c5-13.6 24.3-65.8 24.3-65.8-.4.6 5-13.7 8.1-22.6l4.1 20.4s11.7 56.4 14.1 68H587.1z" fill="#3C58BF" data-id="element-123" />
                      <path d="M232.8 100.3L173.5 261l-6.4-32.4c-11-37.4-45.4-78-83.8-98.3l54.2 204h64l95.3-234H232.8z" fill="#3C58BF" data-id="element-124" />
                      <path d="M119.7 100.3H23.4l-.8 4.7C97.6 121.6 148 163.4 172.1 214l-24.7-125.2c-4.2-17-16.5-24.8-27.7-25.5z" fill="#F9A533" data-id="element-125" />
                    </svg>
                    {/* Mastercard logo inline */}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 750 471" className="h-8 opacity-60" data-id="element-126">
                      <rect width="750" height="471" rx="40" fill="#fff" stroke="#d4d4d8" strokeWidth="8" data-id="element-127" />
                      <circle cx="312" cy="236" r="130" fill="#EB001B" opacity="0.8" data-id="element-128" />
                      <circle cx="438" cy="236" r="130" fill="#F79E1B" opacity="0.8" data-id="element-129" />
                      <path d="M375 141.5c33.4 26.4 54.8 67.1 54.8 112.5s-21.4 86.1-54.8 112.5c-33.4-26.4-54.8-67.1-54.8-112.5s21.4-86.1 54.8-112.5z" fill="#FF5F00" opacity="0.8" data-id="element-130" />
                    </svg>
                    {/* PayPal text */}
                    <span className="text-lg font-bold text-gray-400 tracking-tight" data-id="element-131">
                      PayPal
                    </span>
                  </div>
                  <p className="text-xs text-gray-400 mt-2 flex items-center justify-center gap-1" data-id="element-132">
                    <Lock className="w-3 h-3" data-id="element-133" />
                    Pago 100% Seguro y Encriptado
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}